import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';
import { ClientWithInsuranceListDto } from '@/features/dashboard/insurances/types/ClientWithInsuranceListDto.ts';

const clientsWithInsuranceApi = {
  getAll: async (
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<ClientWithInsuranceListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return await fetchPrivateApi<PagedDto<ClientWithInsuranceListDto>>(
      'POST',
      `clients-with-insurance/all?${params.toString()}`,
      filterCriteria,
    );
  },
  getTableDefinition: async (): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `clients-with-insurance/table-definition`,
    );
  },
};

export default clientsWithInsuranceApi;
